export default [
  'ADD_CREDIT',
  'REMOVE_CREDIT',
  'CONSUME_CREDIT',
  'REFUND_CREDIT',
  'ADD_PROVIDER_CREDIT',
  'REMOVE_PROVIDER_CREDIT',
  'CONSUME_PROVIDER_CREDIT',
  'REFUND_PROVIDER_CREDIT',
  'BALANCE_CHARGE',
  'BALANCE_PAYMENT',
  'ADD_FUND',
  'REMOVE_FUND',
  'TOPUP_CREATE',
  'TOPUP_REFUND',
  'REMITTANCE_CREATE',
  'REMITTANCE_REFUND',
]
